<template lang="pug">
.v-field-type-picker.field-type-picker
	.field-type-picker__container
		.field-type-picker__action
			v-field(
				:field="localField.checkbox"
				v-model="localField.checkbox.value"
				@update:model-value="updateFieldValue(localField.checkbox)"
				)
		v-collapse(:open="localField.checkbox?.value?.length")
			.field-type-picker__list
				template(v-for="(field, index) in localField.fields" :key="index" )
					.field-type-picker__item
						v-field(:field="field" v-model="field.value" @update:model-value="updateFieldValue(field)")

</template>

<script>
import {cloneDeep} from 'lodash';

export default {
	props: {
		field: {
			type: Object,
			default: null,
			required: true
		},

		modelValue: {
			type: [Array, Object, String, Number, Boolean, Symbol, Date],
			default: null
		}
	},

	emits: [
		'update:model-value'
	],

	data() {
		return {
			localValue: false,
			localField: null,
			localFieldData: {}
		}
	},

	methods: {
		handleInput() {
			this.$emit('update:model-value', this.localValue);
		},

		updateLocalValue() {
			let data = {};

			if(this.localField.checkbox && this.localField.checkbox.value) {
				console.log('update value')
				data = {
					...data,
					[this.localField.checkbox.name] : this.localField.checkbox.value,
				}

				this.localField.fields.reduce((acc, curr) => {
					if(curr.value) {
						acc[curr.name] = curr.value;
					}
					return acc;
				}, data);

			}

			this.localFieldData = data;
		},

		updateFieldValue(field) {
			let data = {};

			// if(typeof field.value === 'object') {
			// 	Object.entries(field.value).forEach(([key, value]) => {
			// 		if(value) {
			// 			data = {
			// 				...data,
			// 				[key]: value,
			// 			}
			// 		}
			// 	})
			// } else {
			this.localFieldData = {
					...this.localFieldData,
					[field.name]: field.value
				}
			// }

			console.log('field.value', [field.name], field.value)

			this.$emit('update:model-value', this.localFieldData);
		},
	},


	watch: {
		field: {
			immediate: true,
			handler() {
				this.localField = cloneDeep(this.field);
			}
		},
		modelValue() {
			this.updateLocalValue();
		}
	},

	created() {
		this.updateLocalValue();
	},

}

</script>